import React from 'react';

const EmptyCheckboxIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.35313 9.35312C6.15938 9.55 5.84062 9.55 5.64687 9.35312L3.64687 7.35312C3.45 7.15937 3.45 6.84062 3.64687 6.64687C3.84062 6.45 4.15938 6.45 4.35313 6.64687L6 8.29375L9.64688 4.64687C9.84063 4.45 10.1594 4.45 10.3531 4.64687C10.55 4.84062 10.55 5.15938 10.3531 5.35313L6.35313 9.35312ZM0 2C0 0.895313 0.895313 0 2 0H12C13.1031 0 14 0.895313 14 2V12C14 13.1031 13.1031 14 12 14H2C0.895313 14 0 13.1031 0 12V2ZM1 2V12C1 12.5531 1.44781 13 2 13H12C12.5531 13 13 12.5531 13 12V2C13 1.44781 12.5531 1 12 1H2C1.44781 1 1 1.44781 1 2Z"
      fill="currentColor"
    />
  </svg>
);

export default EmptyCheckboxIcon;
